<script setup>
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { helperStore } from "@/store/helper"
const helper = helperStore()

const props = defineProps({
    posts:{
        type: Array,
        required: true
    }
})
</script>

<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 mx-auto xl:py-20 pt-20 pb-10">
            <div class="relative">
                <h1 class="text-center text-black font-bold title-font xl:text-2xl text-lg sm:mt-4">{{$t("page_heading.our_blog")}}</h1>
                <div class="absolute bg-gray-300 2xl:w-[623px] xl:w-[590px] lg:w-[450px] md:w-[320px] w-0 h-[1px] left-[0%] top-[45%]"></div>
                <div class="absolute bg-gray-300 2xl:w-[623px] xl:w-[590px] lg:w-[450px] md:w-[320px] w-0 h-[1px] right-[0%] top-[45%]"></div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 2xl:gap-6 gap-4 sm:mt-8 mt-4">
                <Link v-for="post in posts" :key="post.id" :href="route('blog.details', post?.slug)"
                    class="rounded shadow-lg transform hover:scale-105 transition duration-500 wow animate__animated animate__zoomIn">
                    <div class="block w-full 2xl:h-[135px] xl:h-[130px] sm:h-[100px] h-[105px] rounded-t overflow-hidden">
                    <VLazyImage :src="post?.image" :title="post?.slug" class="w-full h-full object-center object-cover" />
                </div>
                <div class="p-4">
                    <div class="h-44">

                        <h2 class="title-font xl:text-xl text-lg sm:mb-2 text-center font-semibold text-black">
                            {{ locale === 'BN' ? helper.textShort(post?.bn_title, 30) : helper.textShort(post?.title, 30) }}
                         </h2>

                        <p class=" text-gray-400 sm:text-sm text-xs text-center font-light">{{post?.created_at.human_long}}</p>

                        <p class="leading-relaxed mb-2 text-gray-500 text-sm mt-2" v-html="locale === 'BN' ? helper.textShort(post?.bn_content,180) : helper.textShort(post?.content,180)"></p>
                    </div>
                    <Link :href="route('blog.details', post?.slug)"
                        class="font-bold py-1 px-2 uppercase xl:text-[14px] text-[12px] hover:bg-[#D3EDF0] hover:bg-opacity-[0.3] transition cursor-pointer text-black">{{ $t("common.read_more") }}</Link>
                </div>
                </Link>
            </div>
        </div>
    </section>
</template>

<style scoped></style>
